(() => {
  document.addEventListener("click", async event => {
    const link = event.target.closest?.("[data-vc-cookie-preferences]");
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const banner = window.privacyBanner;
    if (typeof banner?.showPreferences !== "function") return;
    event.preventDefault();
    if (link.getAttribute("aria-busy") === "true") return;
    link.setAttribute("aria-busy", "true");
    try {
      await banner.showPreferences();
    } catch {
      window.location.assign(link.href);
    } finally {
      link.removeAttribute("aria-busy");
    }
  });
})();
